export const API_RESOURCES = {
  ASSEMBLY_META: 'assembly-meta',
  ASSEMBLY_PART_META: 'assembly-part-meta',
  DESIGN_FILE: 'design-file',
  AUTO_DOCUMENT_PARSING_JOB: 'automatic-document-parsing-job',
  DOCUMENT: 'document',
  DOCUMENT_PARSER_INSTRUCTION: 'document-parser-instruction',
  DOCUMENT_PARSER_INSTRUCTION_REPORT: 'document-parser-instruction-report',
  FEATURE: 'feature',
  PRINTER: 'printer',
  PRINTER_TYPE: 'printer-type',
  POST_PROCESSOR: 'post-processor',
  POST_PROCESSOR_TYPE: 'post-processor-type',
  MATERIAL: 'material',
  MATERIAL_CONTAINER: 'material-container',
  MATERIAL_BATCH: 'material-batch',
  MATERIAL_LOT: 'material-lot',
  MATERIAL_STOCK_ACTION: 'material-stock-action',
  MATERIAL_STOCK_ACTION_RELATIONSHIP: 'material-stock-action-relationship',
  MATERIAL_BATCH_ACTION: 'material-batch-action',
  MATERIAL_CONTAINER_ACTION: 'material-container-action',
  RUN: 'run',
  RUN_ACTUALS: 'run-actuals',
  RUN_ACTUALS_ADDITIVE: 'run-actuals-additive',
  PRINT: 'print',
  PRODUCT: 'product',
  PIECE: 'piece',
  PIECES_BY_RUN: 'pieces-by-run',
  LINE_ITEM: 'line-item',
  MODEL: 'model',
  EXTERNAL_BUILDS: 'external-builds',
  ORDER: 'order',
  SCHEDULE_RUNS: 'schedule_runs',
  TIME_ENTRY: 'time-entry',
  TOOLING_STOCK: 'tooling-stock',
  STOCK: 'stock',
  TOOL_LINK: 'tool-link',
  TOOLING_STOCK_ACTION: 'tooling-stock-action',
  TOOLING_TYPE: 'tooling-type',
  WORK_INSTRUCTION: 'work-instruction',
  WORK_INSTRUCTION_REPORT: 'work-instruction-report',
  WORK_INSTRUCTION_REPORT_ACTION: 'work-instruction-report-action',
  WORK_CHECKLIST: 'work-checklist',
  WORK_CHECKLIST_FOR_RESOURCE: 'work-checklists-for-resource',
  WORKFLOW: 'workflow',
  CUSTOM_GROUP: 'custom-group',
  SHIPMENT: 'shipment',
  SHIPPING: 'shipping',
  // Permissions system check data
  // (based on Public Group, but with extended bureau permissions check, see BE implementation for more details)
  ACCESS_INFO_FOR_RESOURCE: 'access-info-for-resource',
  RUN_TRANSFORMATION: 'run-transformation',
  PROCESS_STEP: 'process-step',
  COMMENT: 'comment',
  USERS: 'users',
  SAMPLE: 'sample',
  SUMMARY: 'summary',
  LOCATION: 'location',
  SUB_LOCATION: 'sub-location',
  LABEL: 'label',
  LABEL_RELATIONSHIP: 'label-relationship',
  BUREAU_SETTINGS: 'bureau-settings',
  CURRENCY_CONVERSION: 'currency-conversion',
  ROLE: 'role',
  MLINE_MATERIAL_HANDLING_SYSTEM: 'mline-material-handling-system',
  MLINE_LASER_PROCESSING_SYSTEM: 'mline-laser-processing-system',
  MATERIAL_BATCH_ACTION_TRANSACTION: 'material-batch-action-transaction',
  SERVICE_PROVIDER_JOB: 'service-provider-job',
  CUSTOM_FIELD: 'custom_field',
  RUN_MATERIAL: 'run-material',
  BUREAU_BRANDING: 'bureau-branding',
  MAINTENANCE_REQUIREMENT: 'maintenance-requirement',
  MAINTENANCE_EVENT: 'maintenance-event',
  MAINTENANCE_EVENT_REQUIREMENT: 'maintenance-event-requirement',
  MAINTENANCE_INSTRUCTION_REPORT: 'maintenance-instruction-report',
  MAINTENANCE_DUE: 'maintenance-due',
  DOWNTIME: 'downtime',
};

// Proper names for resources when scanning QR codes
export const API_RESOURCES_TITLE_MAP = {
  [API_RESOURCES.PRINTER]: 'Printer',
  [API_RESOURCES.MATERIAL_CONTAINER]: 'Material Container',
  [API_RESOURCES.MATERIAL_BATCH]: 'Material Batch',
  [API_RESOURCES.POST_PROCESSOR]: 'MHS',
  [API_RESOURCES.MATERIAL_LOT]: 'Material Lot',
  [API_RESOURCES.RUN]: 'Run',
  [API_RESOURCES.TOOLING_STOCK]: 'Tool',
};

export const API_RESOURCES_MAP = {
  [API_RESOURCES.ASSEMBLY_META]: 'assembly meta',
  [API_RESOURCES.ASSEMBLY_PART_META]: 'assembly part meta',
  [API_RESOURCES.ACCESS_INFO_FOR_RESOURCE]: 'access info for resource',
  [API_RESOURCES.DESIGN_FILE]: 'design file',
  [API_RESOURCES.AUTO_DOCUMENT_PARSING_JOB]: 'auto document parsing job',
  [API_RESOURCES.DOCUMENT]: 'document',
  [API_RESOURCES.CURRENCY_CONVERSION]: 'currency conversion',
  [API_RESOURCES.DOWNTIME]: 'downtime',
  [API_RESOURCES.DOCUMENT_PARSER_INSTRUCTION]: 'document parser instruction',
  [API_RESOURCES.DOCUMENT_PARSER_INSTRUCTION_REPORT]: 'document parser instruction report',
  [API_RESOURCES.FEATURE]: 'feature',
  [API_RESOURCES.PRINTER]: 'machine',
  [API_RESOURCES.PRINTER_TYPE]: 'printer type',
  [API_RESOURCES.POST_PROCESSOR]: 'machine',
  [API_RESOURCES.POST_PROCESSOR_TYPE]: 'post-processor-type',
  [API_RESOURCES.MATERIAL]: 'material',
  [API_RESOURCES.MATERIAL_CONTAINER]: 'container',
  [API_RESOURCES.MAINTENANCE_EVENT]: 'maintenance event',
  [API_RESOURCES.MAINTENANCE_EVENT_REQUIREMENT]: 'maintenance event requirement',
  [API_RESOURCES.MAINTENANCE_REQUIREMENT]: 'maintenance requirement',
  [API_RESOURCES.MAINTENANCE_INSTRUCTION_REPORT]: 'maintenance instruction report',
  [API_RESOURCES.MAINTENANCE_DUE]: 'maintenance due',
  [API_RESOURCES.MATERIAL_BATCH]: 'material batch',
  [API_RESOURCES.MATERIAL_LOT]: 'material lot',
  [API_RESOURCES.MATERIAL_STOCK_ACTION]: 'material stock action',
  [API_RESOURCES.MATERIAL_STOCK_ACTION_RELATIONSHIP]: 'material stock action relationship',
  [API_RESOURCES.STOCK]: 'stock',
  [API_RESOURCES.MATERIAL_BATCH_ACTION]: 'material batch action',
  [API_RESOURCES.MATERIAL_CONTAINER_ACTION]: 'material container action',
  [API_RESOURCES.RUN]: 'run',
  [API_RESOURCES.PRODUCT]: 'product',
  [API_RESOURCES.RUN_ACTUALS]: 'run actuals',
  [API_RESOURCES.RUN_ACTUALS_ADDITIVE]: 'run actuals additive',
  [API_RESOURCES.PRINT]: 'print',
  [API_RESOURCES.PIECE]: 'piece',
  [API_RESOURCES.PIECES_BY_RUN]: 'pieces-by-run',
  [API_RESOURCES.LINE_ITEM]: 'line item',
  [API_RESOURCES.MODEL]: 'model',
  [API_RESOURCES.EXTERNAL_BUILDS]: 'External Build ID',
  [API_RESOURCES.ORDER]: 'order',
  [API_RESOURCES.CUSTOM_GROUP]: 'custom group',
  [API_RESOURCES.SCHEDULE_RUNS]: 'scheduled runs',
  [API_RESOURCES.TIME_ENTRY]: 'time entry',
  [API_RESOURCES.TOOLING_STOCK]: 'tool',
  [API_RESOURCES.TOOL_LINK]: 'tool link',
  [API_RESOURCES.TOOLING_STOCK_ACTION]: 'tool action',
  [API_RESOURCES.TOOLING_TYPE]: 'tool type',
  [API_RESOURCES.WORK_INSTRUCTION]: 'work instruction',
  [API_RESOURCES.WORK_INSTRUCTION_REPORT]: 'work instruction report',
  [API_RESOURCES.WORK_INSTRUCTION_REPORT_ACTION]: 'work instruction report action',
  [API_RESOURCES.WORK_CHECKLIST_FOR_RESOURCE]: 'work checklists for resource',
  [API_RESOURCES.WORK_CHECKLIST]: 'work checklist',
  [API_RESOURCES.WORKFLOW]: 'workflow',
  [API_RESOURCES.SHIPMENT]: 'shipment',
  [API_RESOURCES.PROCESS_STEP]: 'process step',
  [API_RESOURCES.COMMENT]: 'comments',
  [API_RESOURCES.USERS]: 'users',
  [API_RESOURCES.ROLE]: 'role',
  [API_RESOURCES.RUN_TRANSFORMATION]: 'run-transformation',
  [API_RESOURCES.SAMPLE]: 'sample',
  [API_RESOURCES.SUMMARY]: 'summary',
  [API_RESOURCES.SUB_LOCATION]: 'sub-location',
  [API_RESOURCES.SHIPPING]: 'shipping',
  [API_RESOURCES.LOCATION]: 'location',
  [API_RESOURCES.LABEL]: 'label',
  [API_RESOURCES.LABEL_RELATIONSHIP]: 'label relationship',
  [API_RESOURCES.BUREAU_SETTINGS]: 'bureau-settings',
  [API_RESOURCES.ROLE]: 'role',
  [API_RESOURCES.MLINE_MATERIAL_HANDLING_SYSTEM]: 'mline-material-handling-system',
  [API_RESOURCES.MLINE_LASER_PROCESSING_SYSTEM]: 'mline-laser-processing-system',
  [API_RESOURCES.MATERIAL_BATCH_ACTION_TRANSACTION]: 'material-batch-action-transaction',
  [API_RESOURCES.SERVICE_PROVIDER_JOB]: 'service-provider-job',
  [API_RESOURCES.CUSTOM_FIELD]: 'custom_field',
  [API_RESOURCES.RUN_MATERIAL]: 'run-material',
  [API_RESOURCES.BUREAU_BRANDING]: 'bureau-branding',
};

export const ACCESS_INFO_ACTION_TYPES = {
  EDIT: 'edit', // PUT request
  DELETE: 'delete', // DELETE request
  USE: 'use', // using an entity URI in other entity field. E.g. `process_step.workstation_type`, etc.
  // Edge-case actions
  REDO: 'redo', // `redo` action is a Run transformation on some/all of Run.Prints provided for a Run resource
  REMANUFACTURE: 'remanufacture', // `remanufacture` is a Run transformation action, provided on a piece resource
  CHANGE_WORKFLOW: 'change_workflow', // `change workflow` is a Run transformation action, provided on a piece resource
};

export const LINE_ITEM_COMPOSITION_TYPES = {
  SINGLE_MESH_PRODUCT: 'single-mesh-product', // Regular 1 model product line item
  CO_PRINT: 'co-print', // co-printed multi-mesh line item (main co-print assembly line item)
  CO_PRINT_PART: 'co-print-part', // co-printed multi-mesh line item part
  ASSEMBLY: 'assembly', // main glue/magnet assembly line item
  ASSEMBLY_PART: 'assembly-part', // glue/magnet assembly part line item
};

export const RUN_STATUS = {
  created: 'created',
  calculating: 'calculating',
  calculated: 'calculated',
  queued: 'queued',
  queuedReady: 'queued-work-ready',
  inProgress: 'in-progress',
  paused: 'paused',
  complete: 'complete',
  error: 'error',
  cancelled: 'cancelled',
};

// In backend implementation it's like the same statuses, as in run,
// but also with `created` and `incomplete` statuses
export const PRINT_STATUSES = Object.assign({}, RUN_STATUS, {
  CREATED: 'created',
  INCOMPLETE: 'incomplete',
});

export const PRINT_ERROR_STATUSES = [
  PRINT_STATUSES.error,
  PRINT_STATUSES.cancelled,
  PRINT_STATUSES.INCOMPLETE,
];

export const PRINT_WORKFLOW_STATUSES = {
  COMPLETE: 'complete',
  CANCELLED: 'cancelled',
  ERROR: 'error',
  QUEUED: 'queued',
};

export const PRINT_STATUSES_TO_VARIANT = {
  [PRINT_WORKFLOW_STATUSES.COMPLETE]: 'info',
  [PRINT_WORKFLOW_STATUSES.CANCELLED]: 'default',
  [PRINT_WORKFLOW_STATUSES.ERROR]: 'error',
  [PRINT_WORKFLOW_STATUSES.QUEUED]: 'success',
};

export const RUN_STATUS_ORDER = [
  RUN_STATUS.created,
  RUN_STATUS.calculating,
  RUN_STATUS.calculated,
  RUN_STATUS.queued,
  RUN_STATUS.queuedReady,
  RUN_STATUS.inProgress,
  RUN_STATUS.paused,
  RUN_STATUS.complete,
  RUN_STATUS.error,
  RUN_STATUS.cancelled,
];

export const RUN_STATUS_LABELS = {
  [RUN_STATUS.created]: 'Created',
  [RUN_STATUS.calculating]: 'Calculating',
  [RUN_STATUS.calculated]: 'Calculated',
  [RUN_STATUS.queued]: 'Queued',
  [RUN_STATUS.queuedReady]: 'Queued Work Ready',
  [RUN_STATUS.inProgress]: 'In Progress',
  [RUN_STATUS.paused]: 'Paused',
  [RUN_STATUS.complete]: 'Completed',
  [RUN_STATUS.error]: 'Failed',
  [RUN_STATUS.cancelled]: 'Cancelled',
};

export const STATUS_BADGE_COLORS = {
  [RUN_STATUS.inProgress]: '#fff4db',
  [RUN_STATUS.complete]: '#e6fcf3',
  [RUN_STATUS.error]: '#fce6e6',
  [RUN_STATUS.cancelled]: '#f0f0f0',
  [RUN_STATUS.queued]: '#e5f4fb',
  [RUN_STATUS.queuedReady]: '#e9fbf4',
};

export const STATUS_BADGE_BORDER_COLORS = {
  [RUN_STATUS.inProgress]: '#ffd88a',
  [RUN_STATUS.complete]: '#a9eed8',
  [RUN_STATUS.error]: '#f5b5b5',
  [RUN_STATUS.cancelled]: '#d3d3d3',
  [RUN_STATUS.queued]: '#b8e2f3',
  [RUN_STATUS.queuedReady]: '#b8efdd',
};

export const STATUS_BADGE_TEXT_COLORS = {
  [RUN_STATUS.inProgress]: '#e9a100',
  [RUN_STATUS.complete]: '#2eb98f',
  [RUN_STATUS.error]: '#d23232',
  [RUN_STATUS.cancelled]: '#7f7f7f',
  [RUN_STATUS.queued]: '#39a1c1',
  [RUN_STATUS.queuedReady]: '#1f9d6c',
};

export const RUN_OPERATIONS = {
  PRINTING: 'printing',
  POST_PROCESSING: 'post-processing',
  SHIPPING: 'shipping',
};

export const SHIPMENT_STATUS = {
  new: 'new',
  queued: 'queued',
  inTransit: 'in_transit',
  received: 'received',
  error: 'error',
  cancelled: 'cancelled',
};

export const SHIPMENT_STATUS_LABELS = {
  [SHIPMENT_STATUS.new]: 'New',
  [SHIPMENT_STATUS.queued]: 'Queued',
  [SHIPMENT_STATUS.inTransit]: 'In Transit',
  [SHIPMENT_STATUS.received]: 'Received',
  [SHIPMENT_STATUS.error]: 'Error',
  [SHIPMENT_STATUS.cancelled]: 'Cancelled',
};

export const FINAL_SHIPMENT_STATUSES = [
  SHIPMENT_STATUS.inTransit,
  SHIPMENT_STATUS.received,
  SHIPMENT_STATUS.cancelled,
  SHIPMENT_STATUS.error,
];

export const SHIPPING_TO_SHIPMENT_STATUS_MAP = {
  [RUN_STATUS.queuedReady]: SHIPMENT_STATUS.new,
  [RUN_STATUS.complete]: SHIPMENT_STATUS.inTransit,
  [RUN_STATUS.inProgress]: SHIPMENT_STATUS.queued,
  [RUN_STATUS.queued]: SHIPMENT_STATUS.queued,
  [RUN_STATUS.calculated]: SHIPMENT_STATUS.new,
  [RUN_STATUS.paused]: SHIPMENT_STATUS.queued,
  [RUN_STATUS.error]: SHIPMENT_STATUS.error,
  [RUN_STATUS.cancelled]: SHIPMENT_STATUS.cancelled,
};

export const NCR_FLAG = 'flag_non_conformance';

export const PIECE_STATUS = {
  NEW: 'new',
  CONFIRMED: 'confirmed',
  QUEUED_FOR_PRINTING: 'queued-for-printing',
  PRINTING: 'printing',
  QUEUED_FOR_POST_PROCESSING: 'queued-for-post-processing',
  POST_PROCESSING: 'post-processing',
  QUEUED_FOR_SHIPPING: 'queued-for-shipping',
  SHIPPING: 'shipping',
  COMPLETE: 'complete',
  INCOMPLETE: 'incomplete',
  CANCELLED: 'cancelled',
  ERROR: 'error',
};

export const COLORS = {
  PURPLE: '#9F86FF',
  BLUE: '#1CA8DD',
  YELLOW: '#E4D836',
  ORANGE: '#FFA500',
  GRAY: '#555555',
  GREEN: '#1BC98E',
  RED: '#E64759',
  WHITE: '#FFFFFF',
  BLACK: '#000000',
};

export const PIECE_STATUS_BADGE_COLORS = {
  [PIECE_STATUS.NEW]: '#e5f4fb',
  [PIECE_STATUS.CONFIRMED]: '#e9fbf4',
  [PIECE_STATUS.QUEUED_FOR_PRINTING]: '#e5f4fb',
  [PIECE_STATUS.PRINTING]: '#fff4db',
  [PIECE_STATUS.QUEUED_FOR_POST_PROCESSING]: '#e5f4fb',
  [PIECE_STATUS.POST_PROCESSING]: '#fff4db',
  [PIECE_STATUS.QUEUED_FOR_SHIPPING]: '#e5f4fb',
  [PIECE_STATUS.SHIPPING]: '#e9fbf4',
  [PIECE_STATUS.COMPLETE]: '#e6fcf3',
  [PIECE_STATUS.INCOMPLETE]: '#f0f0f0',
  [PIECE_STATUS.CANCELLED]: '#f0f0f0',
  [PIECE_STATUS.ERROR]: '#fce6e6',
};

export const PIECE_STATUS_BADGE_BORDER_COLORS = {
  [PIECE_STATUS.NEW]: '#b8e2f3',
  [PIECE_STATUS.CONFIRMED]: '#b8efdd',
  [PIECE_STATUS.QUEUED_FOR_PRINTING]: '#b8e2f3',
  [PIECE_STATUS.PRINTING]: '#ffd88a',
  [PIECE_STATUS.QUEUED_FOR_POST_PROCESSING]: '#b8e2f3',
  [PIECE_STATUS.POST_PROCESSING]: '#ffd88a',
  [PIECE_STATUS.QUEUED_FOR_SHIPPING]: '#b8e2f3',
  [PIECE_STATUS.SHIPPING]: '#b8efdd',
  [PIECE_STATUS.COMPLETE]: '#a9eed8',
  [PIECE_STATUS.INCOMPLETE]: '#d3d3d3',
  [PIECE_STATUS.CANCELLED]: '#d3d3d3',
  [PIECE_STATUS.ERROR]: '#f5b5b5',
};

export const PIECE_STATUS_BADGE_TEXT_COLORS = {
  [PIECE_STATUS.NEW]: '#39a1c1',
  [PIECE_STATUS.CONFIRMED]: '#1f9d6c',
  [PIECE_STATUS.QUEUED_FOR_PRINTING]: '#39a1c1',
  [PIECE_STATUS.PRINTING]: '#e9a100',
  [PIECE_STATUS.QUEUED_FOR_POST_PROCESSING]: '#39a1c1',
  [PIECE_STATUS.POST_PROCESSING]: '#e9a100',
  [PIECE_STATUS.QUEUED_FOR_SHIPPING]: '#39a1c1',
  [PIECE_STATUS.SHIPPING]: '#1f9d6c',
  [PIECE_STATUS.COMPLETE]: '#2eb98f',
  [PIECE_STATUS.INCOMPLETE]: '#7f7f7f',
  [PIECE_STATUS.CANCELLED]: '#7f7f7f',
  [PIECE_STATUS.ERROR]: '#d23232',
};

export const PIECE_TYPES = {
  PRODUCT: 'product',
  SPECIMEN: 'specimen',
  // Legacy, not used anywhere
  WASTE: 'waste',
  TOOLING: 'tooling',
};

export const WORK_INSTRUCTION_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  CHECKBOX: 'checkbox',
  NO_ENTRY: 'no entry',
  RANGE: 'range',
  DOCUMENT: 'document',
  PICTURE: 'picture',
  SINGLE_SELECT_DROPDOWN: 'single-selection-dropdown',
  OUTPUT_AT_LOCATION: 'output-at-location',
};

export const WORK_INSTRUCTION_DOCUMENT_TYPES = [
  WORK_INSTRUCTION_TYPES.DOCUMENT,
  WORK_INSTRUCTION_TYPES.PICTURE,
];

export const WORK_INSTRUCTION_REPORT_TYPE_ANSWERS = {
  [WORK_INSTRUCTION_TYPES.NO_ENTRY]: 'No Entry',
  [WORK_INSTRUCTION_TYPES.CHECKBOX]: 'Checked',
  [WORK_INSTRUCTION_TYPES.DOCUMENT]: 'Uploaded',
  [WORK_INSTRUCTION_TYPES.PICTURE]: 'Uploaded',
};

export const MATERIAL_BATCH_ACTIONS = {
  CREATE_INITIAL_BATCH: 'create_initial_batch',
  MACHINE_LOAD: 'machine_load',
  BLEND_BATCHES: 'blend_batches',
  MACHINE_UNLOAD_CHAMBER: 'machine_unload_chamber',
  UNLOAD_RECLAIMED_MATERIAL: 'unload_reclaimed_material',
  SPLIT_BATCH: 'split_batch',
  SPLIT_BATCH_CONTAINER: 'split_batch_container',
  ADD_CONTAINER: 'add_container',
  CONTAINERIZE_BATCH: 'containerize_batch',
  MACHINE_UNLOAD_HOPPER: 'machine_unload_hopper',
  SCRAP_BATCH: 'scrap_batch',
  SIEVE: 'sieve',
  TEST: 'test',
  START_TEST: 'start_test',
  MACHINE_TOP_OFF: 'machine_top_off',
  RELOCATE: 'relocate',
  TREATMENT: 'treatment',
  DEFER_MODULAR_BUILD: 'defer_modular_build',
};

export const RUN_ACTIONS = {
  SCAN_TOOLING_STOCK: 'scan_tooling_stock',
  PRODUCTION_CHANGE: 'production_change',
};

export const PRINTER_ACTIONS = {
  SCAN_EXTERNAL_BUILD_ID: 'scan_external_build_ud',
  LOAD_MATERIAL: 'load_material',
};

export const PERMANENT_CONTAINER_ACTIONS = {
  LOAD_MATERIAL: 'load_container',
  LOAD_MATERIAL_BATCH: 'load_material_batch',
  TOP_OFF: 'top_off_container',
  TRANSFER_MATERIAL: 'transfer_container',
  SPLIT_CONTAINER: 'split_container',
  MACHINE_LOAD: 'machine_load',
  BLEND_CONTAINERS: 'blend_containers',
  SCRAP: 'scrap_container',
  UNLOAD_UNUSED_MATERIAL: 'unload_unused_material',
  UNLOAD_RECLAIMED_MATERIAL: 'unload_reclaimed_material',
  RELOCATE: 'relocate_container',
  SIEVE_BATCH: 'sieve_batch',
  UNLOAD_TO_CONTAINER: 'action_unload_to_container',
  CONTAINER_UNLOAD: 'action_container_unload',
  MATERIAL_LOAD: 'load_material',
  UNLOAD_CYCLONE: 'unload_cyclone',
  SIEVE: 'sieve',
  TREATMENT: 'treatment',
  TEST: 'test',
  UNLOAD_CONTAINER: 'unload_container',
  UPDATE_MODULE_TARE: 'update_module_tare',
};

export const MLINE_ACTIONS = {
  DOCK_MODULE: 'dock_module',
  UNDOCK_MODULE: 'undock_module',
};

export const MLINE_ACTIONS_VERBOSE = {
  [MLINE_ACTIONS.DOCK_MODULE]: 'Dock Module',
  [MLINE_ACTIONS.UNDOCK_MODULE]: 'Undock Module',
};

export const MATERIAL_BATCH_ACTIONS_VERBOSE = {
  [MATERIAL_BATCH_ACTIONS.CREATE_INITIAL_BATCH]: 'Initial Batch Process',
  [MATERIAL_BATCH_ACTIONS.MACHINE_LOAD]: 'Machine Load',
  [MATERIAL_BATCH_ACTIONS.BLEND_BATCHES]: 'Blend Batches',
  [MATERIAL_BATCH_ACTIONS.MACHINE_UNLOAD_CHAMBER]: 'Machine Unload Chamber',
  [MATERIAL_BATCH_ACTIONS.SPLIT_BATCH]: 'Split Batch',
  [MATERIAL_BATCH_ACTIONS.SPLIT_BATCH_CONTAINER]: 'Split Batch Container',
  [MATERIAL_BATCH_ACTIONS.ADD_CONTAINER]: 'Add Container',
  [MATERIAL_BATCH_ACTIONS.CONTAINERIZE_BATCH]: 'Containerize Batch',
  [MATERIAL_BATCH_ACTIONS.MACHINE_UNLOAD_HOPPER]: 'Machine Unload Hopper',
  [MATERIAL_BATCH_ACTIONS.SCRAP_BATCH]: 'Scrap Batch',
  [MATERIAL_BATCH_ACTIONS.SIEVE]: 'Sieve',
  [MATERIAL_BATCH_ACTIONS.RELOCATE]: 'Relocate',
  [MATERIAL_BATCH_ACTIONS.TREATMENT]: 'Treatment',
  [MATERIAL_BATCH_ACTIONS.TEST]: 'Test',
  [MATERIAL_BATCH_ACTIONS.START_TEST]: 'Start Test',
  [MATERIAL_BATCH_ACTIONS.MACHINE_TOP_OFF]: 'Top Off',
  [MATERIAL_BATCH_ACTIONS.UNLOAD_RECLAIMED_MATERIAL]: 'Unload Reclaimed Material',
  [MATERIAL_BATCH_ACTIONS.UNLOAD_RECLAIMED_MATERIAL]: 'Unload Reclaimed Material',
  [MATERIAL_BATCH_ACTIONS.DEFER_MODULAR_BUILD]: 'Defer Modular Build',
};

export const RUN_ACTIONS_VERBOSE = {
  [RUN_ACTIONS.SCAN_TOOLING_STOCK]: 'Scan Tool',
  [RUN_ACTIONS.PRODUCTION_CHANGE]: 'Production Change',
};

export const PERMANENT_CONTAINER_ACTIONS_VERBOSE = {
  [PERMANENT_CONTAINER_ACTIONS.LOAD_MATERIAL]: 'Fill Container',
  [PERMANENT_CONTAINER_ACTIONS.LOAD_MATERIAL_BATCH]: 'Fill Container',
  [PERMANENT_CONTAINER_ACTIONS.TOP_OFF]: 'Top Off',
  [PERMANENT_CONTAINER_ACTIONS.TRANSFER_MATERIAL]: 'Transfer Material',
  [PERMANENT_CONTAINER_ACTIONS.RELOCATE]: 'Relocate',
  [PERMANENT_CONTAINER_ACTIONS.SCRAP]: 'Scrap Container',
  [PERMANENT_CONTAINER_ACTIONS.UNLOAD_UNUSED_MATERIAL]: 'Unload Material',
  [PERMANENT_CONTAINER_ACTIONS.UNLOAD_RECLAIMED_MATERIAL]: 'Unload Reclaimed Material',
  [PERMANENT_CONTAINER_ACTIONS.SIEVE_BATCH]: 'Sieve Batch',
  [PERMANENT_CONTAINER_ACTIONS.SIEVE]: 'Sieve Container',
  [PERMANENT_CONTAINER_ACTIONS.SPLIT_CONTAINER]: 'Split Container',
  [PERMANENT_CONTAINER_ACTIONS.UNLOAD_CYCLONE]: 'Unload Cyclone',
  [PERMANENT_CONTAINER_ACTIONS.UNLOAD_CONTAINER]: 'Unload Container',
};

export const MATERIAL_BATCH_STATUSES = {
  NEW: 'new',
  IN_USE: 'in_use',
  IDLE: 'idle',
  DONE: 'done',
  CONSUMED: 'consumed',
};

export const MATERIAL_BATCH_POWDER_QUALITY_STATUSES = {
  NEW: 'new',
  SIEVED: 'sieved',
  DONE: 'done',
  UNKNOWN: 'unknown',
  UNSIEVED: 'unsieved',
};

export const PERMANENT_CONTAINER_STATUSES = {
  NEW: 'new',
  IN_USE: 'in_use',
  EMPTY: 'empty',
};

export const PERMANENT_CONTAINER_TYPES = {
  PERMANENT: 'permanent',
  DISPOSABLE: 'disposable',
  CYCLONE: 'cyclone',
  DOSE: 'dose',
  BUILD: 'build',
  OVERFLOW: 'overflow',
};

export const TOOLING_STOCK_STATUSES = {
  NEW: 'new',
  IN_USE: 'in-use',
  IDLE: 'idle',
  NEEDS_REFURBISHMENT: 'needs-refurbishment',
  DOING_REFURBISHMENT: 'doing-refurbishment',
  REFURBISHED: 'refurbished',
  ARCHIVED: 'archived',
};

export const MATERIAL_BATCH_WARNING_POWDER_QUALITY_STATUSES = [
  MATERIAL_BATCH_POWDER_QUALITY_STATUSES.UNKNOWN,
  MATERIAL_BATCH_POWDER_QUALITY_STATUSES.UNSIEVED,
];

export const MATERIAL_CONTAINER_STATUSES = {
  NEW: 'new',
  IN_USE: 'in_use',
  EMPTY: 'empty',
};

export const MATERIAL_BATCH_CUSTOM_STATUSES = {
  IN_TESTING: 'in_testing',
  TESTING_COMPLETE: 'testing_complete',
};

export const MATERIAL_BATCH_STATUS_VERBOSE = {
  [MATERIAL_BATCH_STATUSES.NEW]: 'New',
  [MATERIAL_BATCH_STATUSES.IN_USE]: 'In Use',
  [MATERIAL_BATCH_STATUSES.IDLE]: 'Idle',
  [MATERIAL_BATCH_STATUSES.DONE]: 'Done',
  [MATERIAL_BATCH_STATUSES.CONSUMED]: 'Consumed',
};

export const PERMANENT_CONTAINER_TYPES_VERBOSE = {
  [PERMANENT_CONTAINER_TYPES.PERMANENT]: 'Permanent Container',
  [PERMANENT_CONTAINER_TYPES.DISPOSABLE]: 'Disposable',
  [PERMANENT_CONTAINER_TYPES.CYCLONE]: 'Cyclone',
  [PERMANENT_CONTAINER_TYPES.DOSE]: 'Dose',
  [PERMANENT_CONTAINER_TYPES.BUILD]: 'Build',
  [PERMANENT_CONTAINER_TYPES.OVERFLOW]: 'Overflow',
};
export const TOOLING_STOCK_STATUS_VERBOSE = {
  [TOOLING_STOCK_STATUSES.NEW]: 'New',
  [TOOLING_STOCK_STATUSES.IN_USE]: 'In Use',
  [TOOLING_STOCK_STATUSES.IDLE]: 'Ready For Use',
  [TOOLING_STOCK_STATUSES.NEEDS_REFURBISHMENT]: 'Needs Refurbishment',
  [TOOLING_STOCK_STATUSES.DOING_REFURBISHMENT]: 'Doing Refurbishment',
  [TOOLING_STOCK_STATUSES.REFURBISHED]: 'Refurbished',
  [TOOLING_STOCK_STATUSES.ARCHIVED]: 'Archived',
};

export const PERMANENT_CONTAINER_STATUS_VERBOSE = {
  [PERMANENT_CONTAINER_STATUSES.NEW]: 'New',
  [PERMANENT_CONTAINER_STATUSES.IN_USE]: 'In Use',
  [PERMANENT_CONTAINER_STATUSES.EMPTY]: 'Empty',
};

export const WORK_INSTRUCTION_FILE_TYPES = [
  WORK_INSTRUCTION_TYPES.PICTURE,
  WORK_INSTRUCTION_TYPES.DOCUMENT,
];

export const LOCALSTORAGE_KEYS = {
  DEBUG_MODE: 'debugMode',
  AUTOLOGOUT_AFTER: 'autologoutAfter',
  SCAN_MODE: 'scanMode',
  UNITS_SETTINGS: 'unitsSettings',
  ACTION_SCANNED_CONTAINERS: 'actionScannedContainers',
  AUTO_PARSE_TEMPLATE: 'autoParseTemplate',
  NAVIGATION_HISTORY: 'navigationHistory',
  PIECE_SCAN_VIEW_PREFERENCE: 'pieceScanViewPreference',
};

export const REFERENCE_TABLE_NAMES = {
  WORK_INSTRUCTION_REPORT: 'work_instruction_report',
};

export const TIME_ENTRY_RELATED_TABLE_NAME = {
  RUN: 'run',
  PREP_TASK_RECORD: 'prep_task_record',
};

export const TIME_ENTRY_CATEGORIES = {
  ATTENDING: 'attending',
  MACHINE_RUNNING: 'machine-running',
  // Preparation workflow feature (is not used in QR):
  IN_PROGRESS: 'in-progress',
  ON_HOLD: 'on-hold',
};

export const PRINT_TYPES = {
  PRODUCT: 'product',
  SPECIMEN: 'specimen',
  // For future use
  WASTE: 'waste',
  TOOLING: 'tooling',
};

export const WORK_INSTRUCTION_UNITS = {
  MM: 'mm',
  CM: 'cm',
  INCH: 'inch',
  GRAM: 'gram',
  KG: 'kg',
  LB: 'lb',
};

export const WORK_INSTRUCTION_REPORT_UNITS_VERBOSE = {
  [WORK_INSTRUCTION_UNITS.MM]: 'mm',
  [WORK_INSTRUCTION_UNITS.CM]: 'cm',
  [WORK_INSTRUCTION_UNITS.INCH]: 'in',
  [WORK_INSTRUCTION_UNITS.GRAM]: 'g',
  [WORK_INSTRUCTION_UNITS.KG]: 'kg',
  [WORK_INSTRUCTION_UNITS.LB]: 'lb',
};

export const MODEL_UNITS_VERBOSE = {
  [WORK_INSTRUCTION_UNITS.MM]: 'Millimeters',
  [WORK_INSTRUCTION_UNITS.CM]: 'Centimeters',
  [WORK_INSTRUCTION_UNITS.INCH]: 'Inches',
};

export const WORKFLOW_TYPES = {
  SPECIMEN: 'specimen',
  ADDITIVE_MANUFACTURING: 'additive_manufacturing',
  POWDER_MANUFACTURING: 'powder_manufacturing',
};

export const ALLOWED_DOCUMENT_UPLOAD_FORMATS = [
  'doc',
  'docx',
  'pdf',
  'stl',
  'mp3',
  'dxf',
  'csv',
  'xls',
  'xlsx',
  'jpeg',
  'png',
  'obj',
  'stp',
  'step',
  '3mf',
  'dae',
  'ply',
  'igs',
  'brep',
  'catpart',
  'cmb',
  'zip',
];

// TODO This variable is created to track points where do we need to fetch
//  all non-paginated objects.
//  Must be removed after implementing algorithm for disabling pagination
export const PAGINATION_IGNORE_DEFAULT_LIMIT = 5000;

export const DEFAULT_LOGON_TIMEOUT = 3600 * 1000;
export const LOGON_WARNING_TIMEOUT = 30 * 1000;

export const CONTACTLESS_LOGIN_ENABLED = 'contactlessLoginEnabled';

export const BUREAU_BARCODE_FORMAT = {
  QR: 'qr',
  BARCODE: 'barcode',
};

export const SCAN_BUTTON_STATES = {
  initialized: 'initialized',
  loading: 'loading',
  success: 'success',
};

export const IDENTITY_PROVIDER_TYPE = {
  SAML: 'SAML',
  LDAPS: 'LDAPS',
};

export const BARCODE_SCANNER_STATES = {
  ready: 'ready',
  inactive: 'inactive',
  idle: 'idle',
};

export const SHORT_UUID_LENGTH = 8;
export const FULL_UUID_LENGTH = 36;

export const BATCH_STATUS_COLOR_MAP = {
  [MATERIAL_BATCH_STATUSES.NEW]: COLORS.PURPLE,
  [MATERIAL_BATCH_STATUSES.IN_USE]: COLORS.ORANGE,
  [MATERIAL_BATCH_STATUSES.DONE]: COLORS.GREEN,
  [MATERIAL_BATCH_STATUSES.CONSUMED]: COLORS.GRAY,
  [MATERIAL_BATCH_STATUSES.IDLE]: COLORS.ORANGE,
};

export const PERMANENT_CONTAINER_STATUS_COLOR_MAP = {
  [PERMANENT_CONTAINER_STATUSES.NEW]: COLORS.PURPLE,
  [PERMANENT_CONTAINER_STATUSES.IN_USE]: COLORS.ORANGE,
  [PERMANENT_CONTAINER_STATUSES.EMPTY]: COLORS.GRAY,
};

export const TOOLING_STOCK_STATUS_COLOR_MAP = {
  [TOOLING_STOCK_STATUSES.NEW]: COLORS.PURPLE,
  [TOOLING_STOCK_STATUSES.IDLE]: COLORS.GREEN,
  [TOOLING_STOCK_STATUSES.IN_USE]: COLORS.ORANGE,
  [TOOLING_STOCK_STATUSES.NEEDS_REFURBISHMENT]: COLORS.YELLOW,
  [TOOLING_STOCK_STATUSES.DOING_REFURBISHMENT]: COLORS.ORANGE,
  [TOOLING_STOCK_STATUSES.REFURBISHED]: COLORS.GREEN,
  [TOOLING_STOCK_STATUSES.ARCHIVED]: COLORS.GRAY,
};

export const RUN_STATUS_COLOR_MAP = {
  [RUN_STATUS.calculating]: COLORS.YELLOW,
  [RUN_STATUS.calculated]: COLORS.PURPLE,
  [RUN_STATUS.queued]: COLORS.BLUE,
  [RUN_STATUS.inProgress]: COLORS.ORANGE,
  [RUN_STATUS.paused]: COLORS.GRAY,
  [RUN_STATUS.complete]: COLORS.GREEN,
  [RUN_STATUS.error]: COLORS.RED,
  [RUN_STATUS.cancelled]: COLORS.GRAY,
};

export const STATUS_COLOR_CODE_TYPES = {
  BATCH_STATUS: 'batch_status',
  PERMANENT_CONTAINER_STATUS: 'permanent_container_status',
  TOOLING_STOCK_STATUS: 'tooling_stock_status',
  RUN_STATUS: 'run_status',
};

export const STATUS_COLOR_CODE_TYPE_TO_COLOR_MAP = {
  [STATUS_COLOR_CODE_TYPES.BATCH_STATUS]: BATCH_STATUS_COLOR_MAP,
  [STATUS_COLOR_CODE_TYPES.PERMANENT_CONTAINER_STATUS]: PERMANENT_CONTAINER_STATUS_COLOR_MAP,
  [STATUS_COLOR_CODE_TYPES.TOOLING_STOCK_STATUS]: TOOLING_STOCK_STATUS_COLOR_MAP,
  [STATUS_COLOR_CODE_TYPES.RUN_STATUS]: RUN_STATUS_COLOR_MAP,
};

export const JSON_ERRORS = {
  INVALID_CREDENTIALS: 'invalid-credentials',
};

export const EXPORT_CONTROL_LABEL_NAMES = {
  UK_THIRD_PARTY: 'UK Third Party',
  US_THIRD_PARTY: 'US Third Party',
  NO_EXPORT_CONTROL: 'No Export Control',
};

export const ITAR_CONTROL_LABEL_NAMES = {
  ITAR_CONTROL: 'ITAR Control',
  NO_ITAR_CONTROL: 'No ITAR Control',
};

export const SKIP_CONTROL_WARNINGS = [
  EXPORT_CONTROL_LABEL_NAMES.NO_EXPORT_CONTROL,
  ITAR_CONTROL_LABEL_NAMES.NO_ITAR_CONTROL,
];

export const TOOLING_STOCK_ACTION_TYPES = {
  RELOCATE: 'relocate',
  RECORD_TESTS: 'record_tests',
  MAKE_READY_FOR_USE: 'make_ready_for_use',
  PUT_INTO_USE: 'put_into_use',
  COMPLETE_USE: 'complete_use',
  MARK_NEEDS_REFURBISH: 'mark_needs_refurbish',
  SEND_TO_REFURBISH: 'send_to_refurbish',
  COMPLETE_REFURBISH: 'complete_refurbish',
  DISCARD: 'discard',
};

export const TOOLING_STOCK_ACTION_VERBOSE = {
  [TOOLING_STOCK_ACTION_TYPES.RELOCATE]: 'Relocate',
  [TOOLING_STOCK_ACTION_TYPES.RECORD_TESTS]: 'Record Tests',
  [TOOLING_STOCK_ACTION_TYPES.MAKE_READY_FOR_USE]: 'Make Ready For Use',
  [TOOLING_STOCK_ACTION_TYPES.PUT_INTO_USE]: 'Put Into Use',
  [TOOLING_STOCK_ACTION_TYPES.COMPLETE_USE]: 'Complete Use',
  [TOOLING_STOCK_ACTION_TYPES.MARK_NEEDS_REFURBISH]: 'Mark Needs Refurbish',
  [TOOLING_STOCK_ACTION_TYPES.SEND_TO_REFURBISH]: 'Send To Refurbish',
  [TOOLING_STOCK_ACTION_TYPES.COMPLETE_REFURBISH]: 'Complete Refurbish',
  [TOOLING_STOCK_ACTION_TYPES.DISCARD]: 'Discard',
};

export const TOOLING_STOCK_ACTION_SUCCESS_MESSAGES = {
  [TOOLING_STOCK_ACTION_TYPES.RELOCATE]: 'The tool has been successfully relocated.',
  [TOOLING_STOCK_ACTION_TYPES.RECORD_TESTS]: 'The tests have been successfully recorded.',
  [TOOLING_STOCK_ACTION_TYPES.SEND_TO_REFURBISH]:
    'The tool has been successfully sent to refurbish.',
  [TOOLING_STOCK_ACTION_TYPES.DISCARD]: 'The tool has been successfully discarded.',
  [TOOLING_STOCK_ACTION_TYPES.MAKE_READY_FOR_USE]: 'The tool is now ready for use.',
  [TOOLING_STOCK_ACTION_TYPES.COMPLETE_REFURBISH]: 'The tool has been successfully refurbished.',
  [TOOLING_STOCK_ACTION_TYPES.COMPLETE_USE]: 'The tool has been successfully used.',
  [TOOLING_STOCK_ACTION_TYPES.MARK_NEEDS_REFURBISH]: 'The tool has been marked for refurbishment.',
};

const TOOLING_STOCK_ALWAYS_ALLOWED_ACTIONS = [
  TOOLING_STOCK_ACTION_TYPES.RELOCATE,
  TOOLING_STOCK_ACTION_TYPES.RECORD_TESTS,
  TOOLING_STOCK_ACTION_TYPES.DISCARD,
  TOOLING_STOCK_ACTION_TYPES.PUT_INTO_USE,
];

export const TOOLING_STOCK_ALLOWED_ACTIONS = {
  [TOOLING_STOCK_STATUSES.NEW]: [
    TOOLING_STOCK_ACTION_TYPES.MAKE_READY_FOR_USE,
    ...TOOLING_STOCK_ALWAYS_ALLOWED_ACTIONS,
  ],
  [TOOLING_STOCK_STATUSES.IDLE]: [
    TOOLING_STOCK_ACTION_TYPES.MARK_NEEDS_REFURBISH,
    ...TOOLING_STOCK_ALWAYS_ALLOWED_ACTIONS,
  ],
  [TOOLING_STOCK_STATUSES.IN_USE]: [
    TOOLING_STOCK_ACTION_TYPES.COMPLETE_USE,
    ...TOOLING_STOCK_ALWAYS_ALLOWED_ACTIONS,
  ],
  [TOOLING_STOCK_STATUSES.NEEDS_REFURBISHMENT]: [
    TOOLING_STOCK_ACTION_TYPES.SEND_TO_REFURBISH,
    ...TOOLING_STOCK_ALWAYS_ALLOWED_ACTIONS,
  ],
  [TOOLING_STOCK_STATUSES.DOING_REFURBISHMENT]: [
    TOOLING_STOCK_ACTION_TYPES.COMPLETE_REFURBISH,
    ...TOOLING_STOCK_ALWAYS_ALLOWED_ACTIONS,
  ],
  [TOOLING_STOCK_STATUSES.REFURBISHED]: [
    TOOLING_STOCK_ACTION_TYPES.MAKE_READY_FOR_USE,
    ...TOOLING_STOCK_ALWAYS_ALLOWED_ACTIONS,
  ],
  [TOOLING_STOCK_STATUSES.ARCHIVED]: [],
};

export const BATCH_CARD_TABS = {
  LOTS: 'lots',
  CONTAINERS: 'containers',
};

export const MATERIAL_BATCH_POWDER_QUALITY_STATUS_MAP = {
  [MATERIAL_BATCH_POWDER_QUALITY_STATUSES.NEW]: 'New',
  [MATERIAL_BATCH_POWDER_QUALITY_STATUSES.SIEVED]: 'Sieved',
  [MATERIAL_BATCH_POWDER_QUALITY_STATUSES.DONE]: 'Done',
  [MATERIAL_BATCH_POWDER_QUALITY_STATUSES.UNKNOWN]: 'Unknown',
  [MATERIAL_BATCH_POWDER_QUALITY_STATUSES.UNSIEVED]: 'Unsieved',
};

export const ALLOWED_RUN_STATUSES_FOR_TOOLING_STOCK_SCAN = [
  RUN_STATUS.queued,
  RUN_STATUS.queuedReady,
  RUN_STATUS.inProgress,
  RUN_STATUS.paused,
];

export const MODEL_UNITS = {
  AUTOMATIC: 'auto',
  MM: 'mm',
  CM: 'cm',
  M: 'm',
  INCHES: 'in',
  FEET: 'feet',
};

export const MODEL_UNIT_COEFFICIENTS = {
  [MODEL_UNITS.MM]: {
    [MODEL_UNITS.M]: 1000,
    [MODEL_UNITS.CM]: 10,
    [MODEL_UNITS.MM]: 1,
    // 1 mm = 0.039370078740157
    [MODEL_UNITS.FEET]: 0.00328084,
    [MODEL_UNITS.INCHES]: 0.039370078740157,
  },
  [MODEL_UNITS.CM]: {
    [MODEL_UNITS.M]: 0.01,
    [MODEL_UNITS.CM]: 1,
    [MODEL_UNITS.MM]: 10,
    // 1 mm = 0.039370078740157
    [MODEL_UNITS.FEET]: 0.0328084,
    [MODEL_UNITS.INCHES]: 0.39370078740157,
  },
  [MODEL_UNITS.M]: {
    [MODEL_UNITS.M]: 1,
    [MODEL_UNITS.CM]: 100,
    [MODEL_UNITS.MM]: 1000,
    // 1 mm = 0.039370078740157
    [MODEL_UNITS.FEET]: 3.28084,
    [MODEL_UNITS.INCHES]: 39.370078740157,
  },
  [MODEL_UNITS.INCHES]: {
    // 1 in = 25.4 mm
    [MODEL_UNITS.M]: 0.254,
    [MODEL_UNITS.CM]: 2.54,
    [MODEL_UNITS.MM]: 25.4,
    [MODEL_UNITS.FEET]: 0.08333,
    [MODEL_UNITS.INCHES]: 1,
  },
  [MODEL_UNITS.FEET]: {
    // 1 in = 25.4 mm
    [MODEL_UNITS.M]: 0.3048,
    [MODEL_UNITS.CM]: 30.48,
    [MODEL_UNITS.MM]: 304.8,
    [MODEL_UNITS.FEET]: 1,
    [MODEL_UNITS.INCHES]: 12,
  },
};

export const MATERIAL_UNITS = {
  GRAM: 'gram',
  KG: 'kg',
  LB: 'lb',
  MM3: 'mm3',
  CM3: 'cm3',
  L: 'l',
  ML: 'ml',
  INCH3: 'inch3',

  // New Dimensional Units
  EACH: 'each',
  FEET: 'feet',
  METER: 'meter',
  SQUARE_METERS: 'meter2',
  SQUARE_FEET: 'feet2',
};

export const MEASUREMENT_SYSTEM = {
  IMPERIAL: 'imperial',
  METRIC: 'metric',
  CUSTOM: 'custom',
};

export const MATERIAL_MASS_UNIT_COEFFICIENTS = {
  [MATERIAL_UNITS.GRAM]: {
    [MATERIAL_UNITS.GRAM]: 1,
    // 1 g = 0.001 kg
    [MATERIAL_UNITS.KG]: 0.001,
    // 1 g = 0.00220462 lb
    [MATERIAL_UNITS.LB]: 0.00220462,
  },
  [MATERIAL_UNITS.KG]: {
    // 1 kg = 1000 g
    [MATERIAL_UNITS.GRAM]: 1000,
    [MATERIAL_UNITS.KG]: 1,
    // 1 kg = 2.20462 lb
    [MATERIAL_UNITS.LB]: 2.20462,
  },
  [MATERIAL_UNITS.LB]: {
    // 1 lb = 453.592 g
    [MATERIAL_UNITS.GRAM]: 453.592,
    // 1 lb = 0.453592 kg
    [MATERIAL_UNITS.KG]: 0.453592,
    [MATERIAL_UNITS.LB]: 1,
  },
};

export const METRIC_UNITS = [
  MATERIAL_UNITS.GRAM,
  MATERIAL_UNITS.KG,
  MATERIAL_UNITS.MM3,
  MATERIAL_UNITS.CM3,
  MATERIAL_UNITS.L,
  MATERIAL_UNITS.ML,
  MATERIAL_UNITS.METER,
  MATERIAL_UNITS.SQUARE_METERS,
];

export const IMPERIAL_UNITS = [
  MATERIAL_UNITS.LB,
  MATERIAL_UNITS.INCH3,
  MATERIAL_UNITS.FEET,
  MATERIAL_UNITS.SQUARE_FEET,
];

export const USER_ROLES = {
  RESTRICTED: 'restricted',
  SERVICE_PROVIDER: 'service-provider',
  VENDOR_SERVICE_PROVIDER: 'vendor-service-provider',
  UNKNOWN: 'unknown',
  MANAGER: 'manager',
  STANDARD_USER: 'standard-user',
  GLOBAL_USER: 'global-user',
  LOCATION_USER: 'location-user',
  SELF_REGISTERED_GUEST: 'self-registered-guest',
  LOCATION_MANAGER: 'location-manager',
};

export const USER_ROLES_WEIGHT = {
  [USER_ROLES.VENDOR_SERVICE_PROVIDER]: 10,
  [USER_ROLES.SERVICE_PROVIDER]: 9,
  [USER_ROLES.MANAGER]: 8,
  [USER_ROLES.LOCATION_MANAGER]: 7,
  [USER_ROLES.STANDARD_USER]: 6,
  [USER_ROLES.GLOBAL_USER]: 5,
  [USER_ROLES.LOCATION_USER]: 4,
  [USER_ROLES.RESTRICTED]: 3,
  [USER_ROLES.SELF_REGISTERED_GUEST]: 2,
  [USER_ROLES.UNKNOWN]: 1,
};

export const VOLUME_UNITS = [
  MATERIAL_UNITS.MM3,
  MATERIAL_UNITS.CM3,
  MATERIAL_UNITS.L,
  MATERIAL_UNITS.ML,
  MATERIAL_UNITS.INCH3,
];

export const WEIGHT_UNITS = [MATERIAL_UNITS.GRAM, MATERIAL_UNITS.KG, MATERIAL_UNITS.LB];

export const METRIC_DEFAULT_UNITS = {
  volume: MATERIAL_UNITS.CM3,
  weight: MATERIAL_UNITS.KG,
  length: MATERIAL_UNITS.METER,
  area: MATERIAL_UNITS.SQUARE_METERS,
};

export const IMPERIAL_DEFAULT_UNITS = {
  volume: MATERIAL_UNITS.INCH3,
  weight: MATERIAL_UNITS.LB,
  length: MATERIAL_UNITS.FEET,
  area: MATERIAL_UNITS.SQUARE_FEET,
};

export const CONVERT_UNITS_MAP = {
  [MATERIAL_UNITS.GRAM]: 'g',
  [MATERIAL_UNITS.KG]: 'kg',
  [MATERIAL_UNITS.LB]: 'lb',
  [MATERIAL_UNITS.MM3]: 'mm3',
  [MATERIAL_UNITS.CM3]: 'cm³',
  [MATERIAL_UNITS.L]: 'l',
  [MATERIAL_UNITS.ML]: 'ml',
  [MATERIAL_UNITS.INCH3]: 'in3',
  [MATERIAL_UNITS.EACH]: 'each',
  [MATERIAL_UNITS.FEET]: 'ft', // Maps to 'ft' in convert-units library
  [MATERIAL_UNITS.METER]: 'm', // Maps to 'm' in convert-units library
  [MATERIAL_UNITS.SQUARE_METERS]: 'm²', // Display only - maps to 'm2' for conversion
  [MATERIAL_UNITS.SQUARE_FEET]: 'ft²', // Display only - maps to 'ft2' for conversion
};

// Mapping for convert-units library (different from display mapping)
export const CONVERT_UNITS_LIB_MAP = {
  [MATERIAL_UNITS.GRAM]: 'g',
  [MATERIAL_UNITS.KG]: 'kg',
  [MATERIAL_UNITS.LB]: 'lb',
  [MATERIAL_UNITS.MM3]: 'mm3',
  [MATERIAL_UNITS.CM3]: 'cm3',
  [MATERIAL_UNITS.L]: 'l',
  [MATERIAL_UNITS.ML]: 'ml',
  [MATERIAL_UNITS.INCH3]: 'in3',
  [MATERIAL_UNITS.EACH]: 'ea', // 'each' measure in convert-units
  [MATERIAL_UNITS.FEET]: 'ft',
  [MATERIAL_UNITS.METER]: 'm',
  [MATERIAL_UNITS.SQUARE_METERS]: 'm2',
  [MATERIAL_UNITS.SQUARE_FEET]: 'ft2',
};

export const LENGTH_UNITS = [MATERIAL_UNITS.FEET, MATERIAL_UNITS.METER];

export const AREA_UNITS = [MATERIAL_UNITS.SQUARE_FEET, MATERIAL_UNITS.SQUARE_METERS];

export const COUNT_UNITS = [MATERIAL_UNITS.EACH];

export const SUPPORT_EMAIL = 'support@authentise.com';
export const SUPPORT_URL = 'https://www.authentise.com/help-pages';

export const MATERIAL_BATCH_ACTIONS_TYPES = {
  reclaimed: 'reclaimed',
  consumed: 'consumed',
};

export const MATERIAL_BATCH_ACTIONS_TYPES_MAP = {
  [MATERIAL_BATCH_ACTIONS_TYPES.reclaimed]: 'Reclaimed',
  [MATERIAL_BATCH_ACTIONS_TYPES.consumed]: 'Consumed',
};

export const GE_SIEVE_MHS_MESSAGE = `The material is currently unsieved. 
Please sieve it prior to loading it into the printer`;

export const COMMON_BACKGROUND_JOB_STATUSES = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETE: 'complete',
  ERROR: 'error',
};

export const MATERIAL_TYPES = {
  BASE: 'base',
  SUPPORT: 'support',
  CONSUMABLE: 'consumable',
  RAW_MATERIAL: 'raw_material',
};

export const MATERIAL_TYPES_MAP = {
  [MATERIAL_TYPES.BASE]: 'Base',
  [MATERIAL_TYPES.SUPPORT]: 'Support',
  [MATERIAL_TYPES.CONSUMABLE]: 'Consumable',
  [MATERIAL_TYPES.RAW_MATERIAL]: 'Raw Material',
};

export const MATERIAL_TYPE_BADGE_MAP = {
  [MATERIAL_TYPES_MAP[MATERIAL_TYPES.BASE]]: {
    color: '#1976D2',
  },
  [MATERIAL_TYPES_MAP[MATERIAL_TYPES.SUPPORT]]: {
    color: '#2E7D32',
  },
  [MATERIAL_TYPES_MAP[MATERIAL_TYPES.CONSUMABLE]]: {
    color: '#EF6C00',
  },
  [MATERIAL_TYPES_MAP[MATERIAL_TYPES.RAW_MATERIAL]]: {
    color: '#8E24AA',
  },
};

export const SERVICE_PROVIDER_JOB_STATUS = {
  BID_REQUESTED: 'bid_requested',
  BID_UPDATED: 'bid_updated',
  BID_NEGOTIATED: 'bid_negotiated',
  SHIPPING_TO: 'shipping_to',
  IN_PROGRESS: 'in_progress',
  SHIPPING_FROM: 'shipping_from',
  COMPLETED: 'completed',
  DECLINED: 'declined',
  CANCELLED: 'cancelled',
};

export const SERVICE_PROVIDER_JOB_END_STATUSES = [
  // On these statuses bureau can't move job to any of another statuses
  // Service Provider don't have access to order and line item on these statuses
  SERVICE_PROVIDER_JOB_STATUS.COMPLETED,
  SERVICE_PROVIDER_JOB_STATUS.CANCELLED,
  SERVICE_PROVIDER_JOB_STATUS.DECLINED,
];

export const PRIORITIES = {
  LOW: 0,
  NORMAL: 65,
  HIGH: 75,
  CRITICAL: 95,
};

export const PRIORITY_BADGE_COLORS = {
  [PRIORITIES.CRITICAL]: '#fce6e6',
  [PRIORITIES.HIGH]: '#fff4db',
  [PRIORITIES.NORMAL]: '#f3e8ff',
  [PRIORITIES.LOW]: '#e5f4fb',
};

export const PRIORITY_BADGE_BORDER_COLORS = {
  [PRIORITIES.CRITICAL]: '#f5b5b5',
  [PRIORITIES.HIGH]: '#ffd88a',
  [PRIORITIES.NORMAL]: '#e9d5ff',
  [PRIORITIES.LOW]: '#b8e2f3',
};

export const PRIORITY_BADGE_TEXT_COLORS = {
  [PRIORITIES.CRITICAL]: '#d23232',
  [PRIORITIES.HIGH]: '#e9a100',
  [PRIORITIES.NORMAL]: '#9333ea',
  [PRIORITIES.LOW]: '#39a1c1',
};

export const PRIORITIES_MAP = {
  [PRIORITIES.CRITICAL]: {
    defaultMessage: 'Critical',
  },
  [PRIORITIES.HIGH]: {
    defaultMessage: 'High',
  },
  [PRIORITIES.NORMAL]: {
    defaultMessage: 'Normal',
  },
  [PRIORITIES.LOW]: {
    defaultMessage: 'Low',
  },
};

export const PRODUCTION_CHANGE = {
  REMANUFACTURE: 'remanufacture',
  SCRAP: 'scrap',
  FLAG_NON_CONFORMANCE: 'flag_non_conformance',
};

export const PRODUCTION_CHANGE_LABELS = {
  [PRODUCTION_CHANGE.REMANUFACTURE]: 'Remanufacture',
  [PRODUCTION_CHANGE.SCRAP]: 'Scrap',
  [PRODUCTION_CHANGE.FLAG_NON_CONFORMANCE]: 'Flag Non-conformance',
};
